import { FC, useEffect } from 'react';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import { menuStore } from '@modules/header/adapter/outbound/stores/menu.store';
import CategoryMenu from './CategoryMenu';
const CategoryMenuLogic: FC = () => {
  const {
    isGinARaiDeeMenuOpen,
    setIsGinARaiDeeMenuOpen
  } = headerStore(state => state);
  const {
    categoryMenu,
    fetchCategoryMenu
  } = menuStore(state => state);
  useEffect(() => {
    if (isGinARaiDeeMenuOpen) fetchCategoryMenu();
  }, [isGinARaiDeeMenuOpen]);
  return <CategoryMenu data={categoryMenu} isCategoryOpen={isGinARaiDeeMenuOpen} setCloseCategory={() => setIsGinARaiDeeMenuOpen(false)} />;
};
export default CategoryMenuLogic;